import api from "./api";
import API_ENDPOINTS from "./apiEndpoints";

// GET users list
export const fetchUsers = async () => {
//   const res = await api.get("/admin/users");
  const res = await api.get(API_ENDPOINTS.FETCH_USERS);
  return res.data;
};
